import Colors from '@dynatrace/strato-design-tokens/colors';

export type GridLines = Array<{
  from: { x?: number; y?: number };
  to: { x?: number; y?: number };
  index: number;
}>;

export type GridPointFrom = GridLines[number]['from'];
export type GridPointTo = GridLines[number]['to'];

export const DEFAULT_STROKE_WIDTH = '1px';
export const DEFAULT_STROKE_COLOR =
  Colors.Background.Field.Neutral.DefaultActive;
export const HIGHLIGHTED_STROKE_WIDTH = '2px';
export const HIGHLIGHTED_STROKE_COLOR = Colors.Text.Neutral.Subdued;

export type GridLineProps = {
  from: GridPointFrom;
  to: GridPointTo;
  highlight?: boolean;
};

export const GridLine = ({ from, to, highlight = false }: GridLineProps) => {
  let stroke = DEFAULT_STROKE_COLOR;
  let strokeWidth = DEFAULT_STROKE_WIDTH;

  if (highlight) {
    stroke = HIGHLIGHTED_STROKE_COLOR;
    strokeWidth = HIGHLIGHTED_STROKE_WIDTH;
  }

  return (
    <line
      x1={from.x}
      y1={from.y}
      x2={to.x}
      y2={to.y}
      stroke={stroke}
      strokeWidth={strokeWidth}
      style={{
        shapeRendering: 'geometricPrecision',
      }}
    />
  );
};
